import React from 'react';
import './Work.css';
import { Link } from 'react-router-dom';

const works = [
  {
    id: 'construction',
    title: 'SiJu Construct',
    desc: 'SiJu Construct is a complete business management platform for construction companies—streamlining planning, execution, and collaboration from the office to the job site.',
    img: '/projects/construction.png',
    href: '#construction',
  },
  {
    id: 'b2b-shop-management',
    title: 'B2B Business Management',
    desc: 'A offline-first comprehensive solution for managing B2B operations, from client onboarding to invoicing.',
    img: '/projects/b2b.png',
    href: '#b2b-shop-management',
  },
  {
    id: 'vocabulary',
    title: 'Vocabulary Builder',
    desc: 'An interactive platform for students to enhance their vocabulary skills.',
    img: '/projects/vocab.png',
    href: '#vocabulary',
  },
  {
    id: 'school-website',
    title: 'School Website',
    desc: 'A modern website for schools to manage their online presence.',
    img: '/school/sc9.png',
    href: '#school-website',
  },
  {
    id: 'tbc',
    title: 'TBC Help Line',
    desc: 'A helpline service platform to provide assistance and support to those in need.',
    img: '/projects/tbc.png',
    href: '#tbc-help-line',
  },
  {
    id: 'family-budget',
    title: 'Family Budget & Expense Tracker',
    desc: 'Local-first family budget and expense tracker with offline support and export/import backups.',
    img: '/projects/expense.png',
    href: '#family-budget',
  },
];

export default function Work() {
  return (
    <section id="work" className="comp-section work" aria-labelledby="work-heading">
      <div className="work-head">
        <h2 id="work-heading">Selected Work</h2>
        <p className="muted">Recent projects, from concept to production.</p>
      </div>

      <div className="work-grid">
        {works.map((w) => (
          <Link key={w.id} className="work-card" to={`/projects/${w.id}`} aria-label={`Open ${w.title} details`}>
            <div className="work-media" aria-hidden>
              <img src={w.img} alt="" loading="lazy" />
            </div>
            <div className="work-body">
              <h3 className="work-title">{w.title}</h3>
              <p className="work-desc">{w.desc}</p>
            </div>
            <span className="work-cta">View →</span>
          </Link>
        ))}
      </div>

      {/* Our Clients subsection */}
      <section className="clients-section" aria-labelledby="clients-heading">
        <div className="clients-head" style={{marginTop:24}}>
          <h2 id="clients-heading">Our Clients</h2>
          <p className="muted">Trusted by teams and companies worldwide.</p>
        </div>

        <div className="clients-grid">
          {[
            { id: 'c1', name: 'Alvi Construction', logo: '/clients/alvi.png' },
            { id: 'c2', name: 'Nur Construction', logo: '/clients/nur.png' },
            { id: 'c3', name: 'In-Lab IT', logo: '/clients/inlab.png' },
            { id: 'c4', name: "Sha Jee's", logo: '/clients/shajee.jpeg' },
            { id: 'c5', name: 'Hilltone Int. Islamic School & College', logo: '/clients/hilltone.png' },
            { id: 'c6', name: 'TBC Help Line', logo: '/clients/tbc.png' },
          ].map((c) => (
            <div key={c.id} className="client-card" title={c.name}>
              <div className="client-logo">
                <img src={c.logo} alt={c.name + ' logo'} loading="lazy" />
              </div>
              <div className="client-name">{c.name}</div>
            </div>
          ))}
        </div>
      </section>
    </section>
  );
}
